/**
 * External dependencies.
 */
import React from 'react'
import { useStaticQuery, graphql } from "gatsby"

/**
 * Internal dependencies.
 */
import './_style.scss'
import { Footer } from "./footer-static"

/**
 * This is default Component Export.
 *
 * @return {*}
 */
export default ( props ) => {

	const data = useStaticQuery(graphql`
		query FooterQuery {
		  footerOptions: wp {
		    acfoptGlobalOptions {
		      acfGlobal {
		        footerCopy
		        footerAzienda
		      }
		    }
		    generalSettings {
		      language
		    }
		  }
		  footerMenu1: allWpMenuItem(filter: {locations: {eq: WP_FOOTER_MENU_1}}) {
		    nodes {
		      id
		      title: label
		      cssClasses
		      uri
		      parentId
		    }
		  }
		  footerMenu2: allWpMenuItem(filter: {locations: {eq: WP_FOOTER_MENU_2}}) {
		    nodes {
		      id
		      title: label
		      cssClasses
		      uri
		      parentId
		    }
		  }
		  footerMenu3: allWpMenuItem(filter: {locations: {eq: WP_FOOTER_MENU_3}}) {
		    nodes {
		      id
		      title: label
		      cssClasses
		      uri
		      parentId
		    }
		  }
		  footerMenu4: allWpMenuItem(filter: {locations: {eq: WP_FOOTER_MENU_4}}) {
		    nodes {
		      id
		      title: label
		      cssClasses
		      uri
		      parentId
		    }
		  }
		  socialMenu: allWpMenuItem(filter: {locations: {eq: WP_FOOTER_SOCIAL_MENU}}) {
		    nodes {
		      id
		      title: label
		      cssClasses
		      uri
		      parentId
		    }
		  }
		  langMenu: allWpMenuItem(filter: {locations: {eq: WP_LANGUAGES_MENU}}) {
		    nodes {
		      id
		      title: label
		      cssClasses
		      uri
		      parentId
		    }
		  }
		  legalMenu: allWpMenuItem(filter: {locations: {eq: WP_FOOTER_LEGAL_MENU}}) {
		    nodes {
		      id
		      title: label
		      cssClasses
		      uri
		      parentId
		    }
		  }
		}
	`)

	return (
		<Footer lang={props.lang} langReplace={props.langReplace} data={ data }/>
	)
}
